import React from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Icon, IconName, Text } from '@src/components/base'

interface ChipProps {
  label: string
  icon: IconName
  style: StyleProp<ViewStyle>
  weight?: 'fill' | 'bold'
}

export const Chip = ({ style, icon, label, weight = 'fill' }: ChipProps) => {
  const styles = useStyleSheet(themedStyles)

  return (
    <View style={[styles.container, style]}>
      <Icon name={icon} size={16} weight={weight} style={styles.surface} />
      <Text type="regular" lineSpacing="none" style={styles.surface}>
        {label}
      </Text>
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    flexDirection: 'row',
    gap: 4,
    borderRadius: 8,
    paddingVertical: 4,
    alignItems: 'center',
    paddingHorizontal: 6,
  },
  surface: {
    color: 'theme.solid.white',
  },
})
